import { render, staticRenderFns } from "./DropPixel.vue?vue&type=template&id=1b157d2b"
import script from "./DropPixel.vue?vue&type=script&lang=js"
export * from "./DropPixel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports